import { ClipLoader } from "react-spinners";
import { AddButton } from "../Header/Header.Styled";
import { PaginationContainer, PaginationText } from "./Pagination.Styled";

// Курсорная пагинация (usePaginatedQuery): «Load more» вместо номеров страниц. Общего числа
// записей Convex не отдаёт (правило: без подсчёта полным сканом) — показывается число загруженных.
type Props = {
    status: "LoadingFirstPage" | "CanLoadMore" | "LoadingMore" | "Exhausted";
    loaded: number;
    label: string;
    onLoadMore: () => void;
};

export default function LoadMore({ status, loaded, label, onLoadMore }: Props) {
    if (status === "LoadingFirstPage") return null;
    return (
        <PaginationContainer>
            <PaginationText>{`Loaded ${label}: ${loaded}`}</PaginationText>
            {status !== "Exhausted" && (
                <AddButton onClick={onLoadMore} disabled={status === "LoadingMore"}>
                    {status === "LoadingMore" ? <ClipLoader color={'#FFFFFF'} size={16} /> : 'Load more'}
                </AddButton>
            )}
        </PaginationContainer>
    );
}
